 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		81: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		81: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"17":"App2DPaymentComplete","18":"AppPayment","19":"AppPaymentComplete","20":"AppPaymentProcessing","21":"BusinessProtect360.Generate","22":"CILeadForm","23":"CIP.FactFormApp","24":"CIProtect360.Dashboard","25":"CIProtect360.Details","26":"CIProtect360.Direct.Generate","27":"CIProtect360.Generate","28":"CampaignLeadForm","29":"CarProtect360","30":"CashCardShield","31":"CommissionStatement","32":"Common.Error","33":"Common.MyInfoCallback","34":"ComplimentaryHomeContents","35":"ConsumerPortal","36":"ContactUs","37":"CorporateTravel","38":"Debug","39":"EMAPortal","40":"EarlyProtect360Plus","41":"EarlyProtect360Plus.Dashboard","42":"EarlyProtect360Plus.Details","43":"FamilyProtect360","44":"FilipinoBond","45":"FlashPayShieldWithUpgrade","46":"FraudProtect360","47":"HIProtect360Protect360","48":"HomeProtect360","49":"HomeProtectLite","50":"HomeSafe","51":"HomeStarterKit","52":"InternalDemoCookie","53":"KeymanProtect360","54":"KeymanProtect360.Dashboard","55":"KeymanProtect360.Details","56":"LeadForm","57":"Loan Protect 360 Renewal","58":"LoanProtect360","59":"LoanProtect360.Dashboard","60":"LoanProtect360.Details","61":"MaidProtect360","62":"MotoringCardShieldWithUpgrade","63":"Motorshow2020","64":"PhoneProtect360","65":"PowerAgentPortal","66":"Prestige","67":"Prestige.Secured","68":"PublicHousingAssured","69":"ReviewUs","70":"SOA","71":"SingaporeTravelPass","72":"Touristcard","73":"TravelAssured","74":"TravelAssuredPlus","75":"TravelProtect360","76":"TravelProtect360Plus","77":"cileadform","78":"currencyconverter","80":"motorshow","82":"transferprotect360pro","83":"vCashCard","84":"weather"}[chunkId]||chunkId) + "." + {"0":"f0860918","1":"ff98baf6","2":"07823454","3":"deea7dd2","4":"73f9aee4","5":"14a86b4d","6":"8bef35aa","7":"b869e0cd","8":"79b4c526","9":"04c46e7d","10":"db985441","11":"3b647a07","12":"09b80863","13":"eb59f680","14":"1cf659a5","15":"23d9ad0c","16":"afdf45f3","17":"b5f52f09","18":"6e3de998","19":"2dee3d44","20":"34a0fffe","21":"e265583a","22":"491f3daf","23":"c86de652","24":"ce339124","25":"ca9ae346","26":"96da47d6","27":"21159f9a","28":"88c011c6","29":"24c0956b","30":"a4c4b83c","31":"59eb868c","32":"17f5754c","33":"7ff52689","34":"37841beb","35":"f2ddf660","36":"56f4f6e4","37":"d4010045","38":"9d8db24a","39":"bd95339a","40":"9502567c","41":"89537880","42":"1b24dd8f","43":"685f6619","44":"d669cb5c","45":"c3a22a6b","46":"15c174b8","47":"d54e33ce","48":"8a2437dd","49":"26f6721d","50":"ae2d123f","51":"4f270d65","52":"3b9f4d0c","53":"50de013f","54":"ed61d8cd","55":"216f76d8","56":"9cbd442b","57":"0e8e9c36","58":"3d489782","59":"ee73a859","60":"664ccdd3","61":"558eea85","62":"9fe792f7","63":"3592e155","64":"3f8a52ef","65":"820b13a7","66":"bb8bb6cc","67":"0b6b1808","68":"bdc314e6","69":"469ba14a","70":"ead65522","71":"d624b1ec","72":"e89de988","73":"2006a25b","74":"96ab8704","75":"ed791d4c","76":"a3d97587","77":"ab136bff","78":"86acd9ce","80":"8e2e7856","82":"c5d9df61","83":"8997609a","84":"c9ed84f1","86":"c7b8ae78","87":"c83ca79c","88":"4403f358","89":"c5e3377f","90":"117d330d","91":"627ba822","92":"23a92c23","93":"cb33e1fa","94":"ac2c1eb7","95":"8e42e4f0","96":"d157e26b","97":"4ea56350","98":"871fedb5","99":"f00cf8eb","100":"7af51f46","101":"affce77d","102":"db5f35fe","103":"7e55f453","104":"38257161","105":"1de13716","106":"8b7e2d4f","107":"82c51d6c","108":"d4dac36d","109":"028917d5","110":"67232dcd","111":"4bf13232","112":"5fc3251c","113":"3306ea96","114":"4e7f5665","115":"746d2c4a","116":"852abaf1","117":"9b490ede","118":"19ec6304","119":"50297389","120":"d37a3bfd","121":"86e68dfc","122":"1efac656","123":"e45ad211","124":"5427c01c","125":"c0511c71","126":"c69f236e","127":"b7de5268","128":"fe1ff706","129":"8d1a2c12","130":"5dddd91e","131":"fb3a875a","132":"6b07db1c","133":"ea348985","134":"8d30212b","135":"77a8719c","136":"5717052a","137":"3c7a6d17","138":"0b514882","139":"b979b3b2","140":"083f9255","141":"c3996098","142":"31fd3cfb","143":"6a8a6192","144":"096f0469","145":"dd480223","146":"9b0077ca","147":"4985a36d","148":"87d5240b","149":"0a27d0b1","150":"9ee07c63","151":"515b94e1","152":"51ee51cb","153":"57e3a59c","154":"984b3c87"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"18":1,"20":1,"21":1,"23":1,"26":1,"28":1,"29":1,"30":1,"31":1,"34":1,"35":1,"37":1,"38":1,"40":1,"43":1,"44":1,"45":1,"46":1,"47":1,"48":1,"49":1,"50":1,"51":1,"53":1,"56":1,"61":1,"62":1,"64":1,"65":1,"66":1,"67":1,"68":1,"70":1,"71":1,"72":1,"73":1,"74":1,"75":1,"76":1,"77":1,"78":1,"80":1,"82":1,"83":1,"84":1,"87":1,"88":1,"89":1,"90":1,"91":1,"92":1,"99":1,"101":1,"106":1,"108":1,"112":1,"114":1,"115":1,"116":1,"117":1,"118":1,"119":1,"120":1,"133":1,"134":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"17":"App2DPaymentComplete","18":"AppPayment","19":"AppPaymentComplete","20":"AppPaymentProcessing","21":"BusinessProtect360.Generate","22":"CILeadForm","23":"CIP.FactFormApp","24":"CIProtect360.Dashboard","25":"CIProtect360.Details","26":"CIProtect360.Direct.Generate","27":"CIProtect360.Generate","28":"CampaignLeadForm","29":"CarProtect360","30":"CashCardShield","31":"CommissionStatement","32":"Common.Error","33":"Common.MyInfoCallback","34":"ComplimentaryHomeContents","35":"ConsumerPortal","36":"ContactUs","37":"CorporateTravel","38":"Debug","39":"EMAPortal","40":"EarlyProtect360Plus","41":"EarlyProtect360Plus.Dashboard","42":"EarlyProtect360Plus.Details","43":"FamilyProtect360","44":"FilipinoBond","45":"FlashPayShieldWithUpgrade","46":"FraudProtect360","47":"HIProtect360Protect360","48":"HomeProtect360","49":"HomeProtectLite","50":"HomeSafe","51":"HomeStarterKit","52":"InternalDemoCookie","53":"KeymanProtect360","54":"KeymanProtect360.Dashboard","55":"KeymanProtect360.Details","56":"LeadForm","57":"Loan Protect 360 Renewal","58":"LoanProtect360","59":"LoanProtect360.Dashboard","60":"LoanProtect360.Details","61":"MaidProtect360","62":"MotoringCardShieldWithUpgrade","63":"Motorshow2020","64":"PhoneProtect360","65":"PowerAgentPortal","66":"Prestige","67":"Prestige.Secured","68":"PublicHousingAssured","69":"ReviewUs","70":"SOA","71":"SingaporeTravelPass","72":"Touristcard","73":"TravelAssured","74":"TravelAssuredPlus","75":"TravelProtect360","76":"TravelProtect360Plus","77":"cileadform","78":"currencyconverter","80":"motorshow","82":"transferprotect360pro","83":"vCashCard","84":"weather"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0","1":"31d6cfe0","2":"31d6cfe0","3":"31d6cfe0","4":"31d6cfe0","5":"31d6cfe0","6":"31d6cfe0","7":"31d6cfe0","8":"31d6cfe0","9":"31d6cfe0","10":"31d6cfe0","11":"31d6cfe0","12":"31d6cfe0","13":"31d6cfe0","14":"31d6cfe0","15":"31d6cfe0","16":"31d6cfe0","17":"31d6cfe0","18":"0a8270f7","19":"31d6cfe0","20":"0a8270f7","21":"3e0c89ae","22":"31d6cfe0","23":"aa3b54e1","24":"31d6cfe0","25":"31d6cfe0","26":"58058363","27":"31d6cfe0","28":"7d5509f1","29":"8b4dd16d","30":"70e3c4a4","31":"aa3b54e1","32":"31d6cfe0","33":"31d6cfe0","34":"1779625a","35":"a0a7763d","36":"31d6cfe0","37":"b5261879","38":"4a2f9c60","39":"31d6cfe0","40":"58058363","41":"31d6cfe0","42":"31d6cfe0","43":"8b4dd16d","44":"8b4dd16d","45":"1779625a","46":"8b4dd16d","47":"8b4dd16d","48":"3075a425","49":"3075a425","50":"3075a425","51":"1779625a","52":"31d6cfe0","53":"58058363","54":"31d6cfe0","55":"31d6cfe0","56":"03dd1e0e","57":"31d6cfe0","58":"31d6cfe0","59":"31d6cfe0","60":"31d6cfe0","61":"fd487f7a","62":"1779625a","63":"31d6cfe0","64":"3075a425","65":"872acbf8","66":"2fc531d7","67":"d12ec057","68":"3075a425","69":"31d6cfe0","70":"aa3b54e1","71":"ae092b8a","72":"168f912f","73":"85e49e50","74":"85e49e50","75":"ae092b8a","76":"85e49e50","77":"d4af0650","78":"7b4f34de","80":"3b8df52f","82":"fd487f7a","83":"33db1852","84":"c30f1711","86":"31d6cfe0","87":"cce35a68","88":"4efd6b30","89":"5fe76a74","90":"09c30e4b","91":"bca5ce90","92":"bca5ce90","93":"31d6cfe0","94":"31d6cfe0","95":"31d6cfe0","96":"31d6cfe0","97":"31d6cfe0","98":"31d6cfe0","99":"a85e37f4","100":"31d6cfe0","101":"a85e37f4","102":"31d6cfe0","103":"31d6cfe0","104":"31d6cfe0","105":"31d6cfe0","106":"a85e37f4","107":"31d6cfe0","108":"a85e37f4","109":"31d6cfe0","110":"31d6cfe0","111":"31d6cfe0","112":"4b48318c","113":"31d6cfe0","114":"4b48318c","115":"4b48318c","116":"4b48318c","117":"4b48318c","118":"4b48318c","119":"4b48318c","120":"4b48318c","121":"31d6cfe0","122":"31d6cfe0","123":"31d6cfe0","124":"31d6cfe0","125":"31d6cfe0","126":"31d6cfe0","127":"31d6cfe0","128":"31d6cfe0","129":"31d6cfe0","130":"31d6cfe0","131":"31d6cfe0","132":"31d6cfe0","133":"5fe6802c","134":"5fe6802c","135":"31d6cfe0","136":"31d6cfe0","137":"31d6cfe0","138":"31d6cfe0","139":"31d6cfe0","140":"31d6cfe0","141":"31d6cfe0","142":"31d6cfe0","143":"31d6cfe0","144":"31d6cfe0","145":"31d6cfe0","146":"31d6cfe0","147":"31d6cfe0","148":"31d6cfe0","149":"31d6cfe0","150":"31d6cfe0","151":"31d6cfe0","152":"31d6cfe0","153":"31d6cfe0","154":"31d6cfe0"}[chunkId] + ".chunk.css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.hlas.com.sg/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = this["webpackJsonphlas-react-app"] = this["webpackJsonphlas-react-app"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
